import { Tabs, useTheme } from "@mui/material";

interface IBybTabBar {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const BybTabBar = ({ children, value, onChange }: IBybTabBar) => {
  const theme = useTheme();

  return (
    <Tabs
      value={value}
      onChange={onChange}
      aria-label="basic tabs example"
      variant="fullWidth"
      sx={{
        padding: theme.spacing(1.5, 2.5),
        minHeight: theme.spacing(1),
      }}
      TabIndicatorProps={{
        sx: {
          bgcolor: "dsSurface.v200",
          height: "100%",
          zIndex: 0,
          borderRadius: theme.spacing(1),
        },
      }}
    >
      {children}
    </Tabs>
  );
};

export default BybTabBar;
